import React, { useState, useRef, useEffect } from "react";
import { RiVoiceprintLine } from "react-icons/ri";
import { IoPlayCircleOutline } from "react-icons/io5";
import { HiOutlinePauseCircle } from "react-icons/hi2";

const AudioMessage = ({ audioUrl, index, role }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const togglePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      const handleEnded = () => setIsPlaying(false);
      audio.addEventListener('ended', handleEnded);
      return () => {
        audio.removeEventListener('ended', handleEnded);
      };
    }
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    }}>
      <button
        onClick={togglePlayPause}
        style={{
          border: 'none',
          background: "none",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: 'white',
          marginRight: '8px',
          padding: 0
        }}
      >
        {isPlaying ? (
          <HiOutlinePauseCircle 
            style={{ color: role === "user" ? "white" : "black" }} 
            size={25} 
          />
        ) : (
          <IoPlayCircleOutline 
            size={25} 
            style={{ color: role === "user" ? "white" : "black" }} 
          />
        )}
      </button>
      <span>
        <RiVoiceprintLine style={{ fontSize: 17 }} />
        <RiVoiceprintLine style={{ fontSize: 17 }} />
        <RiVoiceprintLine style={{ fontSize: 17 }} />
        <RiVoiceprintLine style={{ fontSize: 17 }} />
      </span>
      <div
        style={{
          flex: 1,
          height: '24px',
          background: 'rgba(0, 0, 0, 0.1)',
          borderRadius: '12px',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <audio ref={audioRef} src={audioUrl} />
      </div>
    </div>
  );
};

export default AudioMessage; 